/**
 * テーブルの見出しタグのチェックボックス
 */

import Checkbox from '@src/ui/elements/form/Checkbox';
import { ChangeEvent } from 'react';

type Props = {
  name?: string;
  value?: string;
  checked: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
};

const CellCheckbox = ({
  name,
  value,
  checked,
  onChange,
  className = '',
  disabled = false,
}: Props) => {
  return (
    <label className='grid size-full cursor-pointer place-items-center border-r border-solid border-r-gray-200'>
      <Checkbox
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={className}
        disabled={disabled}
      />
    </label>
  );
};

export default CellCheckbox;
